export default [
  {
    key: 'media_id',
    image: 'image_url',
    label: 'Ikon',
    type: 'image',
    required: true,
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
    maxLength: 255,
  },
  {
    key: 'category',
    label: 'Kategori',
    required: true,
    type: 'select',
    options: [
      { value: 'E_WALLET', text: 'e-Wallet' },
      { value: 'VA', text: 'Virtual Account' },
      { value: 'CC', text: 'Credit Card' },
      { value: 'CSTORE', text: 'Offline Store' },
    ],
  },
  {
    key: 'payment_method_fee',
    label: 'Biaya Layanan',
    type: 'currency',
    min: 0,
    prepend: 'Rp',
    notes: 'Biaya tambahan untuk metode pembayaran',
  },
  {
    key: 'gateway',
    label: 'Payment Gateway',
    required: true,
    type: 'select',
    options: [
      { value: 'midtrans', text: 'Midtrans' },
      { value: 'xendit', text: 'Xendit' },
    ],
  },
  {
    key: 'code',
    label: 'Kode',
    required: true,
    maxLength: 255,
    notes: 'Kode unik untuk identifikasi metode pembayaran dari Penyedia Layanan Pembayaran',
  },
  {
    key: 'is_active',
    label: 'Status',
    type: 'radio',
    value: true,
    options: [
      { value: true, text: 'Aktif' },
      { value: false, text: 'Tidak Aktif' },
    ],
  },
]
